import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { openModal } from '../../../store/Modal/actions';
import { formatSecondsToTime } from '../../../utilities/format';
import { cl } from '../../../utilities/cl';

import SvgPlayVideo from '../../SVG/PlayVideo';
import SvgPlay from '../../SVG/Play';
import SvgPause from '../../SVG/Pause';
import SvgWarning from '../../SVG/Warning';
import description from '../../Settings/sets/ObjectObject/items/description';

const secondsToTimeFormat = (totalSeconds) => {
    if (totalSeconds === 0 || isNaN(totalSeconds)) return '00:00';

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    // Форматируем с ведущими нулями
    const pad = (num) => num.toString().padStart(2, '0');

    if (hours > 0) {
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    } else {
        return `${pad(minutes)}:${pad(seconds)}`;
    }
};

const Track = ({
    className = "",
    variant,
    clipEnded,
    clipDeleted,
    trackIsNew,
    trackWarning,
    isPlaying,
    disabled,
    color,
    id,
    name,
    ctime_d,
    ctime_t,
    mimetype,
    isSelected,
    isMarkItems,
    cliptime = "00:00:00",
    pri,
    filename,
    play,
    pause,
    rewind,
    openModal,
    audio,
    text,
    description: textDescription
}) => {
    const currentTime = audio?.current ? secondsToTimeFormat(audio?.current.currentTime) : "0:00"
    const [state, setState] = useState({
        played: false,
        listLoaded: false,
        opened: false
    });
    const [slider, setSlider] = useState(0);

    const [currentWatcherInterval, setCurrentWatcherInterval] = useState(null);


    useEffect(() => {
        if (isPlaying) {
            startWatch();
        } else {
            killWatcher();
        }

        return () => killWatcher();
    }, [isPlaying, audio]);


    function startWatch() {
        killWatcher(); // Сначала очищаем предыдущий интервал

        if (isPlaying && audio) {
            const interval = setInterval(() => {
                if (isPlaying) {
                    updateTime();
                }
            }, 50);
            setCurrentWatcherInterval(interval);
        }
    }

    function killWatcher(resetTime) {
        if (currentWatcherInterval) {
            clearInterval(currentWatcherInterval);
            setCurrentWatcherInterval(null);
        }
        updateTime(resetTime);
    }


    const updateTime = (resetTime) => {
        let currentTime = "00:00"


        if (resetTime !== true && (audio?.current?.currentTime !== audio?.current?.duration && isPlaying)) {
            // Время
            currentTime = formatSecondsToTime(audio.current?.currentTime)

            // Слайдер

            const sliderPercent = (audio.current?.currentTime / (audio.current?.duration / 100))
            setSlider(sliderPercent)
        }

    }

    const rewinds = (e) => {
        const rect = e.target.getBoundingClientRect()
        const clickPercent = 100 * (e.nativeEvent.offsetX / rect.width)
        const totime = clickPercent * 0.01
        console.log({ totime, audio });
        audio.current.currentTime = audio.current.duration * totime


    }


    const handlePlay = () => {
        let duration;

        if (cliptime) {
            duration = cliptime.split(":").splice(1).join(":");
        }



        const isAudio = (mimetype.indexOf("mp3") !== -1 || mimetype.indexOf("audio") !== -1);
        const isVideo = (mimetype.indexOf("mp4") !== -1 || mimetype.indexOf("video") !== -1);

        if (isAudio) {
            play({
                trackId: id,
                filename: filename,
                name,
                duration
            });
        } else if (isVideo) {
            pause();
            openModal({
                type: "video",
                data: {
                    video: {
                        title: name,
                        mp4: filename,
                    }
                }
            });
        }
    };

    const handlePause = () => {
        pause();
    };

    const handleRewind = (e) => {
        const rect = e.target.getBoundingClientRect();
        const clickPercent = 100 * (e.nativeEvent.offsetX / rect.width);
        const totime = (clickPercent * 0.01);
        rewind(totime);
    };

    const toggleOpen = () => {
        setState(prev => ({
            ...prev,
            listLoaded: true,
            opened: !prev.opened
        }));
    };

    const cliptimeArr = cliptime.split(":");
    const formattedCliptime = `${cliptimeArr[1]}:${cliptimeArr[2]}`;
    const isAudio = (mimetype.indexOf("mp3") !== -1 || mimetype.indexOf("audio") !== -1);

    const combinedClassName = cl(
        className,
        { "Track": [variant] },
        { "selectable-item": ["m-top"] },
        { "opened": state.opened },
        { "playing": isPlaying },
        { "selected": isSelected },
        { "highlighted": isMarkItems },
        { "disabled": disabled },
        { "warning": trackWarning },
        { "clip-ended": clipEnded },
        { "clip-deleted": clipDeleted },
        { "track-is-new": !!trackIsNew },
        { "name-fade": slider === 100 },
    );

    return (
        <section className={combinedClassName} data-track-id={id} title={`${name}. ${text ? "Текст рекламы - " + text + ". " : ""}${textDescription ? " Описание - " + textDescription : ""}`}>
            <header className="Track__header">
                <span className="rewind" onClick={rewinds}></span>

                <span className={cl("slider-1", { "d-none": slider === 0 })} style={{ right: `${100 - slider}%` }}></span>
                <span className={cl("slider-2", { "d-none": slider === 0 })} style={{ right: `${100 - slider}%` }}></span>

                <div className="Tracks__grid">
                    <div className="id">{id}</div>
                    <div className="play"
                        onClick={(e) => {
                            e.stopPropagation();
                        }}>
                        <span onClick={handlePlay}>
                            {isAudio
                                ? <SvgPlay className="icon-play" variant="prim" size="xs1" title="Воспроизвести" />
                                : <SvgPlayVideo className="icon-play" variant="prim" size="xs1" title="Воспроизвести" />
                            }
                        </span>
                        {pause && <span onClick={handlePause}>
                            <SvgPause className="icon-pause" variant="prim" size="xs1" title="Приостановить" />
                        </span>}
                    </div>
                    <div className="name" data-track-id={id}>
                        <h4 data-track-id={id} className="ellipsis desktop selectable-item__color" style={{ color }}>
                            {name.length > 40 ? `${name.slice(0, 38)}…` : name}
                        </h4>
                        {trackWarning
                            ? <h4 data-track-id={id} className="mobile selectable-item__color" style={{ color }}>
                                {name.length > 23 ? `${name.slice(0, 23)}…` : name}
                            </h4>
                            : <h4 data-track-id={id} className="mobile selectable-item__color" style={{ color }}>
                                {name.length > 28 ? `${name.slice(0, 28)}…` : name}
                            </h4>}
                    </div>
                    <div className="ctime" title={ctime_t}>
                        {ctime_d}
                    </div>
                    <div className="time">
                        <span className="from">{currentTime}</span>
                        <span className="to">{formattedCliptime.slice(0, 5)}</span>
                    </div>
                    <div className="pri">
                        {pri && <span className='priText' title='Приоритет трансляции'><b>{pri}</b></span>}
                    </div>
                    <div className="warning">
                        {clipEnded
                            ? <SvgWarning variant="sec" size="sm1" title="Завершено" />
                            : <SvgWarning variant="prim" size="sm1" title="Удалено" />
                        }
                    </div>
                </div>
            </header>
        </section>
    );
};

Track.propTypes = {
    className: PropTypes.string,
    variant: PropTypes.oneOf(["gray"]),
    track: PropTypes.exact({
        id: PropTypes.number,
        name: PropTypes.string,
        src: PropTypes.string,
    }),
    trackWarning: PropTypes.bool,
    clipEnded: PropTypes.bool,
    clipDeleted: PropTypes.bool,
    disabled: PropTypes.bool,
    trackPri: PropTypes.string,
};

const mapStateToProps = (state, props) => ({
    isSelected: state.tracks.selected.includes(props.id),
    isMarkItems: state.marks[state.marks.current].items.includes(props.id),
    isPlaying: state.audio.currentTrack?.trackId === props.id && state.audio.isPlaying,
    audio: state.audio.audio
});

const mapDispatchToProps = {
    openModal
};

export default connect(mapStateToProps, mapDispatchToProps)(Track);